import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationSignalRService } from '@notifications/services/notification-signal-r.service';

@Injectable()
export class NotificationRequestInterceptor implements HttpInterceptor {
  constructor(private notificationSignalRService: NotificationSignalRService){}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //only for localhost
    if (!environment.production && request.url.includes("notification")) {
      const token = this.notificationSignalRService.getToken();

      if (token) {
        request = request.clone({ headers: request.headers.append("Authorization", token) });
      }
    }

    return next.handle(request);
  }
}
